module.exports = __webpack_public_path__ + "img/html-logo.2e4ed85a.png";